"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var height = function height(theme) {
  return (typeof theme.lineHeight === 'string' ? (0, _pixelToNumber["default"])(theme.lineHeight) : (0, _pixelToNumber["default"])(theme.fontSize) * theme.lineHeight) + (0, _pixelToNumber["default"])(theme.paddingTop) + (0, _pixelToNumber["default"])(theme.paddingBottom);
};

var base = function base(_ref) {
  var theme = _ref.theme;
  return {
    display: theme.display,
    minWidth: theme.minWidth,
    minHeight: height(theme) + 'px',
    width: theme.width,
    height: theme.height,
    // default global background
    // по ховеру может быть установлен полупрозрачный BG и из-за этого кнопка становится полупрозрачной (не во всех кейсах подходит)
    background: theme.rootBackground,
    borderRadius: theme.borderRadius
  };
};

var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Root;
exports["default"] = _default;